export const daysOfWeek = 'D_L_M_M_J_V_S'.split('_');
export const monthNames = 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
  '_'
);
export const localeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSZ';
export const localeDisplayFormat = 'DD MMMM y HH:mm [hrs]';
export const localeRangeDisplayFormat = 'DD MMM yyyy';
